import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import companyReducer from './slices/companySlice';
import inviteReducer from './slices/inviteSlice';
import permissionReducer from './slices/permissionSlice'; // Phase 5: RBAC - M3
import permissionGroupReducer from './slices/permissionGroupSlice'; // Phase 5: RBAC - M4
import templateReducer from './slices/templateSlice'; // Phase 6A: Template System
import documentReducer from './slices/documentSlice'; // Phase 6C: Document Wizard
import emailLogReducer from './slices/emailLogSlice'; // Email Log System
import emailTemplateReducer from './slices/emailTemplateSlice'; // Email Template System
import appSettingReducer from './slices/appSettingSlice'; // App Setting System
import creditReducer from './slices/creditSlice'; // Phase 7: Credit System
import creditPackageReducer from './slices/creditPackageSlice'; // Phase 7: Credit System
import templateCategoryReducer from './slices/templateCategorySlice'; // Template Category System

export const store = configureStore({
  reducer: {
    auth: authReducer,
    company: companyReducer,
    invite: inviteReducer,
    permission: permissionReducer, // Phase 5: RBAC - M3
    permissionGroup: permissionGroupReducer, // Phase 5: RBAC - M4
    templates: templateReducer, // Phase 6A: Template System
    documents: documentReducer, // Phase 6C: Document Wizard
    emailLogs: emailLogReducer, // Email Log System
    emailTemplates: emailTemplateReducer, // Email Template System
    appSettings: appSettingReducer, // App Setting System
    credits: creditReducer, // Phase 7: Credit System
    creditPackages: creditPackageReducer, // Phase 7: Credit System
    templateCategories: templateCategoryReducer, // Template Category System
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export default store;
